export default __webpack_public_path__ + "static/SRC 7S7001 - Product Specifications & Technical Data-d89447d56e7a72322420cc91c9172f59.pdf";